import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import TermsView from 'src/views/Terms';
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true,
    isIncidental: true
  }
}));
export default TermsView;